import Button from '@components/Button';
import Image from '@components/Image';
import Row from '@components/Row';
import useProject from '@hooks/useProject';
import useScript from '@hooks/useScript';
import { Fragment } from 'react';

import KakaoIcon from './ic_kakao.svg';
import RecentToolTip from '../RecentToolTip';

const kakaoRedirectUri = import.meta.env.VITE_KAKAO_REDIRECT_URI;
const kakaoScriptUrl = import.meta.env.VITE_KAKAO_SCRIPT_URL;

interface Props {
    isLastLogin?: boolean;
}

function KakaoSignInButton({ isLastLogin }:Props) {
  const project = useProject();
  const kakaoJsKey = import.meta.env.MODE === 'production'
    ? project?.kakaoJavascriptKey : import.meta.env.VITE_KAKAO_JS_KEY;
  const initKakao = () => {
    // @ts-ignore
    if (!window.Kakao.isInitialized()) {
      // @ts-ignore
      window.Kakao.init(kakaoJsKey!);
    }
  };
  const handleKakaoLogin = () => {
    // @ts-ignore
    window.Kakao.Auth.authorize({
      redirectUri: kakaoRedirectUri,
    });
  };
  useScript({ src: kakaoScriptUrl, onLoad: initKakao, enabled: !!kakaoJsKey });
  if (kakaoJsKey) {
    return (
          <Button fullWidth
                  backgroundColor='#FEE500'
                  color='rgba(0, 0, 0, 0.85)'
                  onClick={handleKakaoLogin}>
              <Row spacing={6}>
                  <Image src={KakaoIcon}
                         width={20}
                         height={20}
                         alt='카카오 로그인'/>
                  카카오 로그인
              </Row>
              {isLastLogin && (
                  <RecentToolTip/>
              )}
          </Button>
    );
  }
  return (<Fragment/>);
}

export default KakaoSignInButton;
